<nb-card>
  <nb-card-header>{{ title }}</nb-card-header>
  <nb-card-body>
    <div class="form-view">
      <main>
        <form [formGroup]="form" autocomplete="off">
          <div class="flex-container-horizontal">
            <div class="form-control-group">
              <label class="label" for="input-money-date">Date:</label>
              <input
                nbInput
                fullWidth
                formControlName="moneyDate"
                id="input-money-date"
                placeholder="DD/MM/YYYY"
                [matDatepicker]="moneyDateDatepicker"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="moneyDateDatepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #moneyDateDatepicker
                startView="month"
              ></mat-datepicker>
              <p class="error-message">
                {{
                  utils.handleValidationErrorMessage(
                    form,
                    "moneyDate",
                    errorMessages
                  )
                }}
              </p>
            </div>
            <div class="form-control-group">
              <label class="label" for="input-money-date">Value (£):</label>
              <input
                nbInput
                fullWidth
                formControlName="moneyValue"
                placeholder="Value (£)"
                type="number"
                min="0.01"
                step="0.01"
              />
              <p class="error-message">
                {{
                  utils.handleValidationErrorMessage(
                    form,
                    "moneyValue",
                    errorMessages
                  )
                }}
              </p>
            </div>
          </div>
          <div class="flex-container-horizontal">
            <div *ngIf="type === 'amount-owing'" class="form-control-group">
              <label class="label" for="input-money-expiry-date"
                >Expiry date:</label
              >
              <input
                nbInput
                fullWidth
                formControlName="moneyExpiryDate"
                id="input-money-expiry-date"
                placeholder="DD/MM/YYYY"
                [matDatepicker]="moneyExpiryDateDatepicker"
                autofocus
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="moneyExpiryDateDatepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #moneyExpiryDateDatepicker
                startView="month"
              ></mat-datepicker>
              <div
                *ngIf="form.get('moneyExpiryDate').value"
                id="clear-date"
                (click)="clearMoneyExpiryDate()"
              >
                x
              </div>
              <p class="error-message">
                {{
                  utils.handleValidationErrorMessage(
                    form,
                    "moneyExpiryDate",
                    errorMessages
                  )
                }}
              </p>
            </div>
            <div class="form-control-group">
              <label class="label" for="input-description">Description:</label>
              <input
                nbInput
                fullWidth
                formControlName="description"
                placeholder="Description"
                type="text"
              />
              <p class="error-message">
                {{
                  utils.handleValidationErrorMessage(
                    form,
                    "moneyValue",
                    errorMessages
                  )
                }}
              </p>
            </div>
          </div>
        </form>
      </main>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      class="btn btn-success"
      (click)="saveData()"
      [disabled]="!utils.isFormValid(form) || isLoading"
    >
      <i class="nb-checkmark" aria-hidden="true"></i> Save
    </button>
    <button class="btn btn-danger ml-4" (click)="closeWindow()">
      <i class="nb-close" aria-hidden="true"></i> Close
    </button>
  </nb-card-footer>
</nb-card>
